<template>
  <div>
    <section class="main-content">
        <div class="main-banner">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9">

                      <div id="bs-slider" class="carousel slide" data-ride="carousel">
                          <ol class="carousel-indicators">
                              <li data-target="#bs-slider" v-for="(row, index) in slide" :class="[index==0 ? 'active':'']" :data-slide-to="0"></li>
                          </ol>
                          <div class="carousel-inner" role="listbox">
                              <div class="carousel-item" v-for="(row, index) in slide" :class="[index==0 ? 'active':'']">
                                  <img class="d-block img-fluid" :src="'https://admin.weddingsung.com/upload/slide/'+row.image_path"  :alt="index">
                              </div>
                          </div>
                          <a class="carousel-control-prev" href="#bs-slider" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                          <a class="carousel-control-next" href="#bs-slider" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                      </div>
                    </div>

                    <div class="col-lg-3">
                        <div class="articles-box exlink-box">
                            <a ::href="'/Featured'" target="_blink">
                                <h5 class="title">頂上故事-{{article[0].title}}</h5>
                                <span class="pub_date text-primary">
                                    {{article[0].created_at}}
                                </span>
                                <router-link class="more_link" v-bind:to="'/Featured'">more</router-link>
                                <article class="article-editor">
                                  <p v-html="article[0].context"></p>
                                </article>
                            </a>
                        </div>

                        <div class="articles-box exlink-box" v-for="(row, index) in hot">
                            <a :href="row.link" target="_blink">
                                <h5 class="title">熱門話題-{{row.title}}</h5>
                                <span class="pub_date text-primary">{{row.created_at}}</span>
                                <article class="article-editor">
                                  <p v-html="row.context"></p>
                                </article>
                            </a>
                        </div>

                        <div class="articles-box exlink2" v-if="songSpecial.id>0">
                            <a :href="'/topicview/'+songSpecial.id">
                                <h5 class="title">特別企劃</h5>
                                <span class="sub-title  text-primary">{{songSpecial.title}}</span>
                                <article class="article-image">
                                  <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/song/'+songSpecial.image_path" />
                                </article>  
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles bck-index-bg">
                            <h3 class="title"><span>本週推薦歌曲</span></h3>
                            <div class="articles-items">
                                <div class="articles-box refsongs-box" v-for="(row, index) in songLatest">
                                    <div class="row" v-if="index === 0">
                                        <div class="col-md-5">
                                            <div class="embed-responsive embed-responsive-16by9">
                                                <iframe class="embed-responsive-item" :src="songLatest[0].link"></iframe>
                                            </div>
                                        </div>
                                        <div class="col-md-7">
                                            <div class="text">
                                                <h5 class="title">{{songLatest[0].title}}</h5>
                                                <span class="pub_date text-primary">{{songLatest[0].updated_at}}</span>
                                                <article class="article-editor">
                                                  <p class="txt">
                                                      {{songLatest[0].context | truncate(250) | doubledot}}
                                                  </p>
                                                </article>
                                                <a class="btn btn-outline-primary btn-sm" :href="'/songs/'+songLatest[0].id">MORE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="articles-box refsongs-box" v-for="(row, index) in songLatest">
                                    <div class="row" v-if="index === 1">
                                      <div class="col-md-5 push-md-7">
                                          <div class="embed-responsive embed-responsive-16by9">
                                              <iframe class="embed-responsive-item" :src="row.link"></iframe>
                                          </div>
                                      </div>
                                        <div class="col-md-7 pull-md-5">
                                            <div class="text">
                                                <h5 class="title">{{row.title}}</h5>
                                                <span class="pub_date text-primary">{{row.updated_at}}</span>
                                                <article class="article-editor">
                                                  <p class="txt">
                                                    {{row.context | truncate(250) | doubledot}}
                                                  </p>
                                                </article>
                                                <a class="btn btn-outline-primary btn-sm" :href="'/songs/'+row.id">MORE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bck-index bck-articles">
                            <h3 class="title title-bg-flowers"><span>歌曲使用分享</span></h3>
                            <div class="articles-items">
                                <div class="articles-box refsongs-box ref-hn">
                                    <div class="row" v-for="(row, index) in SongShare" style="margin-bottom:20px">
                                        <div class="col-md-5">
                                            <div class="embed-responsive embed-responsive-16by9">
                                                <iframe class="embed-responsive-item" :src="row.link"></iframe>
                                            </div>
                                        </div>
                                        <div class="col-md-7">
                                            <div class="text">
                                                <h5 class="title">{{row.title}}</h5>
                                                <span class="pub_date text-primary">{{row.created_at}}</span>
                                                <article class="article-editor">
                                                  <p>{{row.context | doubledot}}</p>
                                                </article>
                                                <a class="btn btn-outline-primary btn-sm" :href="'/songs/'+row.song_id">MORE</a>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h3 class="title title-bg-music"><span>精選分類</span></h3>
                            <div class="articles-items">
                                <div class="row">
                                    <div class="col-lg-4 col-md-6" v-for="(row, index) in songCategory">
                                        <div class="articles-box catalog-box">
                                            <a :href="'/topic/'" v-if="row.id==6">
                                                <figure class="pic articles-pic fitimg">
                                                    <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/song/'+row.image_path" />
                                                </figure>
                                                <div class="text">
                                                    <h5 class="title">{{ row.title }} ({{row.qty}})</h5>
                                                    <!-- <div dangerouslySetInnerHTML={{ __html: "<h1>Hi there!</h1>" }} /> -->
                                                    <article class="article-editor" v-html="row.context"></article>
                                                </div>
                                            </a>
                                            <a :href="'/songCategory/'+row.id" v-else>
                                                <figure class="pic articles-pic fitimg">
                                                    <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/song/'+row.image_path" />
                                                </figure>
                                                <div class="text">
                                                    <h5 class="title">{{ row.title }} ({{row.qty}})</h5>
                                                    <!-- <div dangerouslySetInnerHTML={{ __html: "<h1>Hi there!</h1>" }} /> -->
                                                    <article class="article-editor" v-html="row.context">
                                                    </article>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--
                        <div class="bck-index bck-articles">
                            <h3 class="title title-bg-bird"><span>相關服務夥伴</span></h3>
                            <div class="articles-items">
                                <div class="row">
                                    <div class="col-lg-4 col-md-6" v-for="(row, index) in partnerCategory">
                                        <div class="articles-box relatedlink-box">
                                            <a :href="'/partner/'+row.id">
                                                <figure class="pic articles-pic fitimg">
                                                    <img class="img-fluid" :src="'https://admin.weddingsung.com/upload/partner/'+ row.image_path" />
                                                </figure>
                                                <div class="text">
                                                    <h6 class=title>{{row.title}}</h6>
                                                    <p class="txt">{{row.context}}</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        -->
                    </div>
                </div>
            </div>
        </div>

    </section>
  </div>
</template>

<script>
/* eslint-disable */
import Fanspage from '../components/Fanspage.vue'
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'home',
  data () {
    return {
      api: this.$store.getters.getUri
    }
  },
  computed: {
    ...mapGetters({
      slide: 'getSlide',
      songCategory: 'getSongCategory',
      songLatest: 'getSongLatest',
      songSpecial: 'getSongSpecial',
      SongShare: 'getSongShare',
      partnerCategory: 'getPartnerCategory',
      activity: 'getActivity',
      article: 'getArticle',
      hot: 'getHot'
    })
  },
  components: {
    Fanspage
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ])
  },
  filters: {
    truncate: function (string, value) {
      let str = string.replace(/<\/?[^>]+(>|$)/g, '')
      return str
    },
    doubledot: function (str, value) {
      str = str.replace(/&quot;*/g, '"')
      str = str.replace(/&amp;*/g, '&')
      return str.substring(0, value) + '...'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?e9e64c80